import React from 'react';
import { ClientInvitation } from '../../../../../../hooks/api/useMyOrganizationClientInvitations';
import Text from '../../../../../v2BaseComponents/Text';
import { ProfileListItem } from '../../../../../../primary-record-types/apiTypes/medicalProfileService';
import { ProfileSelect } from '../../../../../v2BaseComponents/Inputs/ProfileMultiSelect';
import getName from '../../../../../../utils/getName';
import urls from '../../../../../../utils/urls';
import { getIntl } from '../../../../../../utils/intl';
import Stack, { contentStackSpacing } from '../../../../../v2BaseComponents/Stack';
import StepCompleteButton from '../../StepCompleteButton';

const intl = getIntl('organization-client-invitation', {
    selectProfile: 'Select a profile',
    selectProfileText:
        "{organizationName} has requested access to {profileName}'s profile. Please select an existing profile to grant access.",
    complete: 'Complete',
});

export type OrganizationClientInvitationOwnProps = {
    clientInvitation: ClientInvitation;
    profiles: ProfileListItem[];
    onProfileSelected: (profileId: string) => void;
    defaultProfileId: string | null;
};

export type OrganizationClientInvitationProps = OrganizationClientInvitationOwnProps;

const OrganizationClientInvitation: React.FC<OrganizationClientInvitationProps> = (props) => {
    const [selectedProfileId, setSelectedProfileId] = React.useState<string | null>(props.defaultProfileId || null);
    return (
        <Stack vertical fullWidth space={contentStackSpacing} align="center">
            <Text variant="body-1">
                {intl('selectProfileText', {
                    organizationName: props.clientInvitation.organization.metadata.name,
                    profileName: getName({
                        firstName: props.clientInvitation.clientFirstName,
                        lastName: props.clientInvitation.clientLastName,
                    }),
                })}
            </Text>
            <ProfileSelect
                title={intl('selectProfile')}
                value={selectedProfileId}
                onChange={setSelectedProfileId}
                testID="organization-invitation-select-profile-select-profile"
                selectOptions={props.profiles.map((profile) => ({
                    label: getName(profile),
                    value: profile.medicalProfileId,
                    testID: getName(profile),
                    avatarUrl: urls.api.medicalProfiles.avatar(profile.medicalProfileId),
                }))}
            />
            <StepCompleteButton
                isDisabled={!selectedProfileId}
                onPress={() => props.onProfileSelected(selectedProfileId!)}
                variant="next"
                testID="organization-invitation-select-existing-profile-next-button"
            />
        </Stack>
    );
};

export default React.memo(OrganizationClientInvitation);
